
export const ERROR_EVENT = {
    UI : "Error_UI",
    API : "Error_Api"
}

export const PERFORMANCE_EVENT = "Performance"

